import * as React from 'react';

const SvgRanking = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.565 32.667h-6.23a4.68 4.68 0 0 0-4.667 4.666V49a2.34 2.34 0 0 0 2.333 2.333h8.564A2.34 2.34 0 0 0 17.898 49V35a2.34 2.34 0 0 0-2.333-2.333ZM31.104 23.333h-6.23A4.68 4.68 0 0 0 20.207 28v21a2.34 2.34 0 0 0 2.333 2.333h10.897A2.34 2.34 0 0 0 35.77 49V28a4.665 4.665 0 0 0-4.666-4.667ZM46.665 39.667h-6.23A2.34 2.34 0 0 0 38.102 42v7a2.34 2.34 0 0 0 2.333 2.333h8.563A2.34 2.34 0 0 0 51.332 49v-4.667a4.68 4.68 0 0 0-4.667-4.666ZM35.022 11.317c.723-.724 1.003-1.587.77-2.334-.233-.746-.957-1.283-1.983-1.446l-2.24-.374c-.094 0-.304-.163-.35-.256l-1.237-2.474c-.933-1.89-3.057-1.89-3.99 0l-1.237 2.474c-.023.093-.233.256-.326.256l-2.24.374c-1.027.163-1.727.7-1.984 1.446-.233.747.047 1.61.77 2.334l1.727 1.75c.093.07.163.35.14.443l-.49 2.147c-.373 1.61.233 2.333.63 2.613.397.28 1.26.653 2.683-.187l2.1-1.236c.094-.07.397-.07.49 0l2.077 1.236c.653.397 1.19.514 1.61.514.49 0 .84-.187 1.05-.327.397-.28 1.003-1.003.63-2.613l-.49-2.147c-.023-.117.047-.373.14-.443l1.75-1.75Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgRanking;
